import * as React from "react";
const SvgOpthamology = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 50 30"
    {...props}
  >
    <g
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      clipPath="url(#opthamology_svg__a)"
    >
      <path
        stroke={props.invert ? '#FFFFFF' : '#061C57'}
        d="M49.042 14.934a41.698 41.698 0 0 1-8.622 7.944c-4.197 2.894-8.766 6.044-15.022 6.176-7.655.161-13.509-4.294-15.885-6.1 0 0-.9-.69-8.555-8.02 1.61-1.201 11.89-12.059 21.316-13.742C28.348.104 36.98 2.308 49.042 14.934Z"
      />
      <path
        stroke={props.color}
        d="M25.005 23.18c4.577 0 8.287-3.662 8.287-8.18s-3.71-8.181-8.287-8.181c-4.577 0-8.287 3.663-8.287 8.181 0 4.518 3.71 8.18 8.287 8.18Z"
      />
    </g>
    <defs>
      <clipPath id="opthamology_svg__a">
        <path fill="#fff" d="M0 0h50v30H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgOpthamology;
